<template> 
  <div style="background-color:white;min-height:500px">
    <v-row>
      <v-col
        cols="12"
        sm="6"
      >
        <img src="@/assets/products/engineering_2.jpg" alt="" height="400" />
      </v-col>
      <v-col
        cols="12"
        sm="6"
      >
        <div style="padding-top:80px;padding-left:0%;">
          <div>
            <p style="font-size:36px;padding:0px;margin:0px;font-weight:200;font-family:Roboto">Engineering Insurance</p>
            
          </div>
          <div style="padding-top:20px">
            <p>In modern society many entities own or operate costly plant and machinery. Infra-structure like roads, dams, power generation and transmission facilities, mineral extraction and processing, Water treatment plants and the many others are required for prosperity.</p> 
            <p>There are risks of loss or damage associated with this area, for which the corporation has policies available, or can be arranged to suit specific circumstances.</p>
          </div>
          <div style="padding-left:25%;padding-top:15px">
            <v-btn
              color="primary"
              rounded
              outlined
              large
              @click="openDrawer(3)"        
            >
              Get a Quote
            </v-btn>
          </div>
        </div>
      </v-col>
    </v-row>
    
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  export default {
    name: 'EngineeringInsurance',
    components: {
      
    },
    data() {
      return {
        
      }
    },
    methods: {
      openDrawer(index){
        this.components.nav_drawer.product_index=index;
        this.components.nav_drawer.mini_variant=false;
        this.components.nav_drawer.expand_on_hover=false;
        
      },
    },
    computed: {
      ...mapGetters({
        user: "user",
        components: "components"
      })
    } 
  }
</script>

